export default "__VITE_ASSET__BAUSiszx__"